import { AsphaltMixDesigns } from '../../../cimsPage/instances/materials'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  create: 'D9FE159E-689A-40CA-BBD7-A7636873E77E',
  edit: '20085B03-FCCB-421F-8623-F07143CA3878',
  view: '08F9A2D2-73F3-44CA-8F41-ACB47EF594CC',
  removeRestore: 'AE00C586-7B20-4F1F-9F22-120E1913AC83',
  object: 'Asphalt Mix Design Target',
  page: AsphaltMixDesigns,
})

export const CreateLIMSAsphaltMixDesignTarget = Create
export const EditLIMSAsphaltMixDesignTarget = Edit
export const RemoveRestoreLIMSAsphaltMixDesignTarget = RemoveRestore
export const ViewLIMSAsphaltMixDesignTarget = View

export type LIMSAsphaltMixDesignTargetPermissionItem =
  | typeof CreateLIMSAsphaltMixDesignTarget
  | typeof EditLIMSAsphaltMixDesignTarget
  | typeof RemoveRestoreLIMSAsphaltMixDesignTarget
  | typeof ViewLIMSAsphaltMixDesignTarget
